
export const getPageChangeApproverURL = (urlId)=>
  `/page-change-approver/${urlId}`;
